<template>
  <header class="header">
    <div class="left_content">
      <div class="logo_box" @click="jumpTo('/')">
        <img class="logo_img" src="./../../assets/images/logo.png" alt="" />
      </div>
      <ul class="navigation_box">
        <li
          class="each_navigation"
          v-for="(item, index) in navigationList"
          :key="index"
          :class="{ active_navigation: item.name === controlActive }"
          @click="jumpTo(item.path)"
        >
          <span>{{ item.title }}</span>
          <p></p>
        </li>
      </ul>
    </div>
    <div class="right_contnet">
      <!-- 公告图标 和 公告提示框部分 -->
      <!-- <div :class="{ controlHasHoverCenter: controlHover }" class="message_box">
        <div class="notice_tips">
          <div class="header_box">
            <p>{{ $t('公告') }}</p>
            <p @click="jumpTo('/notice')">{{ $t('全部通知') }}</p>
          </div>
          <div class="body_box">
            <div v-if="newNoticeList.length > 0" class="notice_box">
              <div class="notice" v-for="(item, index) in newNoticeList" :key="index" @click="jumpTo('/noticeDetail', { id: item.id })">
                <div class="notice_content">
                  <div class="content">
                    <h3 v-html="dealNoticeInfo(item.title, 20)"></h3>
                    <p v-html="dealNoticeInfo(item.content, 45)"></p>
                  </div>
                  <div class="time">{{ item.beforeTime }}</div>
                </div>
              </div>
            </div>
            <NoData v-else height="180px" sceneType="day"></NoData>
          </div>
        </div>
      </div> -->
      <!-- 登录后 | 个人中心图标 和 个人中心提示框-->
      <div
        v-if="isSignIn"
        :class="{ controlHasHoverCenter: controlHover }"
        class="personal_box"
      >
        <div class="personal_tips">
          <div class="user_box" :style="user_bgImage">
            <div class="user_content" @click="jumpTo('/personal')">
              <div class="user_left">
                <p class="account">
                  {{
                    userInfo.isEmail
                      ? userInfo.email
                      : userInfo.isPhone
                      ? userInfo.phone
                      : ''
                  }}
                </p>
                <p class="number">UID:{{ userInfo.userId }}</p>
              </div>
              <div class="user_right">
                <img
                  class="full_img"
                  src="./../../assets/images/personalRight.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <ul class="option_box">
            <li
              v-for="(item, index) in personalOption"
              :key="index"
              @click="jumpTo(item.path)"
            >
              <p v-if="item.reverse" class="option">
                <span>{{ item.tab }}</span>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 登录前 -->
      <div v-else class="sign_register">
        <div
          :class="{ ative_two_bg: controlActive === 'signin' }"
          class="sign"
          @click="jumpTo('/signin')"
        >
          <span class="text">{{ $t('登录') }}</span>
        </div>
        <div
          :class="{ ative_two_bg: controlActive === 'register' }"
          class="register"
          @click="jumpTo('/register')"
        >
          <span class="text">{{ $t('注册') }}</span>
        </div>
      </div>

      <!-- 语言、汇率 和 语言、汇率提示框 -->
      <div
        :class="{ controlHasHoverCenter: controlHover }"
        class="lang_rate_box"
      >
        {{ dealCurrentLangTitle()
        }}<!-- /CNY -->
        <div class="lang_rate_tips">
          <div class="lang_rate_content">
            <div class="lang_box">
              <div class="title">{{ $t('语言') }}</div>
              <div class="type lang">
                <div
                  :class="{ activeType: currentLangType() === item.lang }"
                  class="each_type"
                  v-for="(item, index) of langTypeList"
                  :key="index"
                  @click="handleSwitchLang(item.lang)"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import {
  SET_TOKEN,
  SET_USER_NAME,
  SET_MEMBER_NUMBER,
  SET_USER_INFO,
} from '@/store/mutation-types'
import Cookies from 'js-cookie'
// import { noticeList } from '@/api/notice'
import { userSignOut } from '@/api/sign'
import { dealDateBefore } from '@/utils'
import currentLangType from '@/utils/currentLangType'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'Header',
  data() {
    return {
      user_bgImage: {
        backgroundImage:
          'url(' +
          require('./../../assets/images/gerenxingxi-xingzhuang.png') +
          ')',
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
      },
      navigationList: [
        { title: this.$t('首页'), path: '/', name: 'home' },
        {
          title: this.$t('交易中心'),
          path: '/transaction',
          name: 'transaction',
        },
        {
          title: this.$t('合约'),
          path: '/contract',
          name: 'contract',
        },
        {
          title: this.$t('持仓'),
          path: '/position',
          name: 'position',
        },
        // { title: this.$t('市场'), path: '/market', name: 'market' }
      ],
      personalOption: [
        { tab: this.$t('账户和安全'), path: '/personal', reverse: true },
        { tab: this.$t('身份认证'), path: '/identity', reverse: true },
        { tab: this.$t('资产管理'), path: '/myassets', reverse: true },
        // { tab: this.$t('代币认购'), path: '/subscription', reverse: true },
        { tab: this.$t('邀请奖励'), path: '/inviteFriends', reverse: true },
        { tab: this.$t('退出登录'), path: 'signOut', reverse: true },
      ],
      langTypeList: [
        { title: '简体中文', lang: 'zh' },
        { title: '繁体中文', lang: 'zh_TW' },
        { title: 'English', lang: 'en' },
      ],
      controlActive: '', // 控制导航栏活跃样式
      // newNoticeList: [],
      queryNotice: {
        start: 0,
        offset: 5,
        type: 'Notice',
      },
      controlHover: true,
    }
  },
  // created () {
  //   this.getNoticeList()
  // },
  computed: {
    ...mapGetters(['isSignIn', 'userInfo']),
    ...mapState(['userInfo']),
  },
  watch: {
    $route: {
      handler: function (newVal, oldVal) {
        console.log(11)
        this.controlActive = newVal.name
      },
      immediate: true,
    },
    userInfo: {
      handler(newVal, oldVal) {
        // realNameStatus 为实名认证状态 共有三种状态：0未认证，1审核中，2已认证
        if (newVal.realNameStatus) {
          this.personalOption[1].reverse = false
        } else {
          this.personalOption[1].reverse = true
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    currentLangType,
    dealDateBefore,
    async jumpTo(p, q) {
      if (p === 'signOut') {
        await userSignOut()
        this.$Message.success({
          content: this.$t('操作成功'),
          duration: 0.8,
          onClose: () => {
            this.$store.commit(SET_TOKEN, '')
            this.$store.commit(SET_USER_NAME, '')
            this.$store.commit(SET_MEMBER_NUMBER, '')
            this.$store.commit(SET_USER_INFO, {})
            this.$router.push({ path: '/' })
          },
        })
      } else {
        this.$router.push({ path: p, query: q })
        this.controlHover = false
        setTimeout(() => {
          this.controlHover = true
        }, 500)
      }
    },
    handleSwitchLang(lang) {
      if (this.$i18n.locale !== lang) {
        // this.$i18n.locale = lang
        Cookies.set('lang', lang, { expires: 365 })
        window.location.reload()
      }
    },
    // async getNoticeList () {
    //   const { item } = await noticeList(this.queryNotice)
    //   this.newNoticeList = item
    //   console.log({ item })
    // },
    switchMoney() {
      this.controlHover = false
      setTimeout(() => {
        this.controlHover = true
      }, 500)
    },
    dealNoticeInfo(string, number) {
      if (string.length > number) {
        const result = string.slice(0, number)
        return result + '...'
      } else {
        return string
      }
    },
    dealCurrentLangTitle() {
      for (const item of this.langTypeList) {
        if (currentLangType() === item.lang) {
          return item.title
        }
      }
    },
  },
  filters: {
    strFilter(string, index, total) {
      if (string) {
        const startStr = string.slice(0, index)
        const endStr = string.substr(index + total)
        const result = startStr + '****' + endStr
        return result
      }
    },
  },
}
</script>
<style lang="less" scoped>
.header {
  padding: 10px 50px;
  margin: 0 auto;
  width: 100%;
  // min-width: 1310px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .left_content {
    display: flex;
    flex-direction: row;
    align-items: center;
    .logo_box {
      width: 300px;
      height: 40px;
      cursor: pointer;
      .logo_img {
        width: 100%;
        height: 100%;
      }
    }
    .navigation_box {
      display: flex;
      flex-direction: row;
      .each_navigation {
        margin-right: 30px;
        position: relative;
        span {
          font-size: 16px;
          font-weight: 400;
          color: rgba(175, 186, 204, 1);
          line-height: 22px;
          cursor: pointer;
          &:hover {
            color: rgba(255, 255, 255, 1);
          }
        }
        p {
          position: absolute;
          top: 39px;
          width: 0%;
          height: 2px;
          background: #c02e21;
        }
      }
      // 活跃导航栏样式
      .active_navigation {
        span {
          color: rgba(255, 255, 255, 1);
          font-weight: 500;
          font-family: PingFangSC-Medium, 'PingFang SC';
        }
        p {
          width: 100%;
        }
      }
    }
  }
  .right_contnet {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    .message_box,
    .personal_box {
      margin-left: 10px;
      width: 40px;
      height: 40px;
      cursor: pointer;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    // 公告图标 和 公告提示框部分
    .message_box {
      background-image: url('./../../assets/images/message.png');
      .notice_tips {
        display: none;
        width: 340px;
        position: absolute;
        top: 36px;
        right: 0;
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        .header_box {
          padding: 15px 30px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid rgba(232, 232, 232, 1);
          p {
            height: 30px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
          }
          p:last-child {
            cursor: pointer;
          }
        }
        .body_box {
          padding-bottom: 10px;
          .notice_box {
            .notice {
              padding: 0 20px;
              cursor: pointer;
              .notice_content {
                padding: 10px 0 10px 12px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid rgba(248, 248, 248, 1);
                .content {
                  h3,
                  p {
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    line-height: 20px;
                    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
                  }
                }
                .time {
                  flex-shrink: 0;
                  padding: 5px 15px;
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(66, 179, 250, 1);
                  line-height: 20px;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
                  background: rgba(228, 244, 255, 1);
                  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
                  border-radius: 4px;
                }
              }
              &:hover {
                .notice_content {
                  .content {
                    h3,
                    p {
                      color: rgba(66, 179, 250, 1);
                    }
                  }
                }
                background-color: rgba(0, 0, 0, 0.1);
              }
            }
          }
        }
      }
      &:hover {
        background-image: url('./../../assets/images/activeMessage.png');
      }
    }
    // 登录后 | 个人中心图标 和 个人中心提示框
    .personal_box {
      background-image: url('./../../assets/images/personal.png');
      .personal_tips {
        display: none;
        // min-width: 220px;
        position: absolute;
        top: 36px;
        right: 0;
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        .user_box {
          padding: 20px 30px;
          .user_content {
            display: flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;
            .user_left {
              .account {
                height: 20px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 20px;
                word-break: keep-all;
              }
              .number {
                margin-top: 2px;
                height: 17px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 17px;
                word-break: keep-all;
              }
            }
            .user_right {
              margin-left: 26px;
              width: 32px;
              height: 32px;
            }
          }
        }
        .option_box {
          padding: 10px 0 20px;
          .option {
            padding: 10px 30px;
            cursor: pointer;
            white-space: nowrap;

            span {
              font-size: 14px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 20px;
            }
          }
          .option:hover {
            background: rgba(248, 248, 248, 1);
          }
        }
      }
      &:hover {
        background-image: url('./../../assets/images/activePersonal.png');
      }
    }
    .sign_register {
      margin-left: 15px;
      display: flex;
      flex-direction: row;
      .sign,
      .register {
        padding: 4px 14px;
        border-radius: 4px;
        cursor: pointer;
        .text {
          font-size: 16px;
          font-weight: 400;
          color: rgba(165, 176, 194, 1);
          line-height: 22px;
        }
        &:hover .text {
          // color: rgba(255, 255, 255, 1);
          // font-weight: 500;
        }
      }
      // 动态控制"登录""注册"导航栏背景颜色
      .ative_two_bg {
        background: #ffffff;
        .text {
          color: #1c1b1b;
        }
      }
    }
    // 语言、汇率 和 语言、汇率提示框
    .lang_rate_box {
      margin-left: 10px;
      height: 40px;
      line-height: 40px;
      color: rgba(153, 153, 153, 1);
      // position: relative;
      .lang_rate_tips {
        display: none;
        position: absolute;
        top: 36px;
        right: 0px;
        .lang_rate_content {
          padding: 10px 0 20px;
          display: flex;
          flex-direction: row;
          background: rgba(255, 255, 255, 1);
          border-radius: 4px;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
          .lang_box,
          .rate_box {
            min-width: 120px;
            .title {
              padding: 10px 30px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 20px;
              text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            }
            .type {
              .each_type {
                padding: 10px 30px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 20px;
                text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
                cursor: pointer;
              }
              .activeType,
              .each_type:hover {
                color: rgba(66, 179, 250, 1);
                background: rgba(0, 0, 0, 0.1);
              }
            }
            .lang {
              border-right: 1px solid rgba(232, 232, 232, 1);
            }
          }
        }
      }
    }
    .controlHasHoverCenter:hover {
      .personal_tips,
      .notice_tips,
      .lang_rate_tips {
        display: block;
      }
    }
  }
}
</style>
